import { render, staticRenderFns } from "./UnblockDialog.vue?vue&type=template&id=5e2844a6"
import script from "./UnblockDialog.vue?vue&type=script&lang=js"
export * from "./UnblockDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports